'use strict';

const Base = require('components/Base/Base.js');

require('./IndexThoughts.less');

module.exports = Base.extend({

    el: '.IndexThoughts',

    events: {
        'click span.link-inner': 'onInnerLinkClick',
        'click .CommonText-special2-item span': 'onInnerLinkClick'
    },

    initialize: function () {
        Base.prototype.initialize.call(this, {});
    }
});
